module.exports = __webpack_public_path__ + "images/emoji/mount_fuji.21b8d27dd443978e7a25.png";